export * from './weight-value/weight-value.component';
export * from './score-value/score-value.component';
export * from './report-value/report-value.component';
export * from './height-value/height-value.component';
export * from './tr-data/tr-data.component';
export * from './percentile-value/percentile-value.component';
